import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';


//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    rtl: {
        textAlign: 'right',
    }
});

class EditCvTipoZona extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.cvTipoZona.id ? this.props.cvTipoZona.id : uuidv4(),
            description: this.props.cvTipoZona.descr ? this.props.cvTipoZona.descr : '',
            iKindElemImp: this.props.cvTipoZona.iKindElemImp ? this.props.cvTipoZona.iKindElemImp : 0,

        };

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'description'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            className={classes.textField}
                            margin="normal"
                            autoFocus
                            value={this.state.description}
                            onChange={(event) => this.handleValueChange(event, 'description')}
                        />
                    </FormControl>
{/* 
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'iKindElemImp'}
                            label={'iKindElemImp'}
                            placeholder={'iKindElemImp'}
                            className={classes.textField}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                            value={this.state.iKindElemImp}
                            onChange={(event) => this.handleValueChange(event, 'iKindElemImp')}
                        />
                    </FormControl> */}
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipoZona = {
                            id: this.state.id,
                            descr: this.state.description,
                            iKindElemImp: 1, //parseInt(this.state.iKindElemImp)    //REVIEW!
                        }

                        if (this.props.checkTipoZona(tipoZona)) {

                            this.props.okHandler(tipoZona);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        );
    };

};

EditCvTipoZona.propTypes = {
    cvTipoZona: PropTypes.object.isRequired,
    checkTipoZona: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCvTipoZona);